/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Main View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './mainView';

export const mapStateToPropsMainView = mapStateToProps;
export const mapDispatchToPropsMainView = mapDispatchToProps;

export default connect(
  mapStateToPropsMainView,
  mapDispatchToPropsMainView
)(View);
